import { PATH_DOCUMENTATION, PATH_VIEW } from '@lib/enums/urls';

const DOCUMENT_VIEW_URL_REGEX = new RegExp(
  `^/${PATH_DOCUMENTATION}/[^/?]+/${PATH_VIEW}(?:\\?|$)`,
);

const isDocumentViewUrl = (url: string): boolean =>
  DOCUMENT_VIEW_URL_REGEX.test(url);

export default isDocumentViewUrl;
